import { ClaimExamplesSlider } from './ClaimExamplesSlider';
import { Price } from './Price';
import { TopUSP } from './TopUSP';
import { USPGrid } from './USPGrid';

export const Shop = {
  ClaimExamplesSlider,
  TopUSP,
  Price,
  USPGrid,
};
